// Official campaign social destinations (single source of truth for the frontend).
export const FACEBOOK_PAGE_URL = 'https://www.facebook.com/VoteSteveLesperance';
export const FACEBOOK_REVIEWS_URL = 'https://www.facebook.com/VoteSteveLesperance/reviews';
